import { Moon, Sun } from 'lucide-react';
import { useEffect, useState } from 'react';
import { cx } from '../cx.js';

export type Tema = 'light' | 'dark';
const CHIAVE = 'aulaviva.tema';

export function leggiTemaSalvato(): Tema | null {
  try {
    const v = localStorage.getItem(CHIAVE);
    return v === 'light' || v === 'dark' ? v : null;
  } catch {
    return null;
  }
}

export function applicaTema(tema: Tema) {
  document.documentElement.setAttribute('data-theme', tema);
  try {
    localStorage.setItem(CHIAVE, tema);
  } catch {
    /* archiviazione non disponibile: il tema vale solo per questa pagina */
  }
}

/** Da chiamare una volta all'avvio dell'app, prima del primo render. */
export function inizializzaTema(predefinito: Tema = 'light') {
  const salvato = leggiTemaSalvato();
  document.documentElement.setAttribute('data-theme', salvato ?? predefinito);
}

export interface ThemeToggleProps {
  className?: string;
  testoChiaro?: string;
  testoScuro?: string;
}

export function ThemeToggle({ className, testoChiaro = 'Passa al tema chiaro', testoScuro = 'Passa al tema scuro' }: ThemeToggleProps) {
  const [tema, setTema] = useState<Tema>(() =>
    typeof document !== 'undefined' && document.documentElement.getAttribute('data-theme') === 'dark' ? 'dark' : 'light',
  );
  useEffect(() => {
    applicaTema(tema);
  }, [tema]);
  const scuro = tema === 'dark';
  const Icona = scuro ? Sun : Moon;
  return (
    <button
      type="button"
      onClick={() => setTema(scuro ? 'light' : 'dark')}
      aria-label={scuro ? testoChiaro : testoScuro}
      aria-pressed={scuro}
      className={cx('h-11 w-11 inline-flex items-center justify-center rounded-md text-ink-muted hover:text-ink hover:bg-surface-sunken', className)}
    >
      <Icona aria-hidden size={20} strokeWidth={1.75} />
    </button>
  );
}
